module.exports = __webpack_public_path__ + "img/thumbnail_NineBandedArmadillo_m_normal.af4df575.png";